/**
 * Format the time in range selection when not show time.
 * It will adjust the end range time to 23.59.59 and the start to 00.00.00
 *
 * @returns {number[]} - The formatted date time range in millis. [start, end]
 */
export const formatDateTimeRange = (e: number[]): number[] => {
  if (Array.isArray(e)) {
    const [start, end] = e;

    return [
      new Date(start).setHours(0, 0, 0),
      new Date(end ?? start).setHours(23, 59, 59),
    ];
  }
};
